import { render, staticRenderFns } from "./Windturbine.vue?vue&type=template&id=9740e7c4&"
import script from "./Windturbine.vue?vue&type=script&lang=ts&"
export * from "./Windturbine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports